<template>
  <el-tooltip
      :content="getLabel"
      effect="light"
      placement="top"
      v-if="canConversationsPreserveToggle"
  >
            <span class="btn btn-secondary btn_call btn_call-sm" style="padding: 0.25rem 0.65rem;"
                  @click="togglePreserve">
              <i :class="getIcon"></i>
            </span>
  </el-tooltip>
</template>

<script>
import eventBus from "../../event-bus";

export default {
  props: {
    conversation: Object,
  },

  computed: {
    /**
     * @return {Boolean}
     */
    isPreserved() {
      return Boolean(_.get(this.conversation, 'is_preserved', false));
    },

    /**
     * @return {string}
     */
    getIcon() {
      return this.isPreserved ?
          `fas fa-bookmark` :
          `far fa-bookmark`;
    },

    /**
     * @return {string}
     */
    getLabel() {
      return this.isPreserved ?
          `Unmark as preserved` :
          `Mark as preserved`;
    },

    /**
     * @return {string}
     */
    getConversationsPreserveToggleUrl() {
      return _.get(this.conversation, 'conversationsPreserveToggle');
    },

    /**
     * @return {Boolean}
     */
    canConversationsPreserveToggle() {
      return Boolean(_.get(this.conversation, 'canConversationsPreserveToggle', false));
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    togglePreserve() {
      axios.post(this.getConversationsPreserveToggleUrl)
          .then(this.onMessageUpdated)
          .catch(this.onUpdatedError);
    },

    /**
     * @param {Object} data
     * @return {undefined}
     */
    onMessageUpdated({data}) {
      let item = _.get(data, 'data', {});

      eventBus.$emit('conversation-list-change', item);

      let message = _.get(data, 'message', null);

      if (!_.isNull(message)) {
        this.$message({
          message: message,
          type: 'success',
        });
      }
    },

    /**
     * @param {Object} response
     * @return {undefined}
     */
    onUpdatedError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },
  },
}
</script>

<style scoped>

</style>
